export default "__VITE_ASSET__CZlzFHrS__"